<template>
  <div class="sign-in">
    <div wrapper>
      <div title>NIKE积分管理系统</div>
      <Form :model="form" :rules="rules" ref="form" @submit.native.prevent>
        <FormItem prop="username">
          <Input
            v-model="form.username"
            size="large"
            clearable
            autofocus
            @on-enter="_inputFocus('password')"
          >
            <span slot="prepend">账号</span>
          </Input>
        </FormItem>
        <FormItem prop="password">
          <Input
            type="password"
            v-model="form.password"
            ref="password"
            size="large"
            clearable
            @on-enter="signIn"
          >
            <span slot="prepend">密码</span>
          </Input>
        </FormItem>
        <FormItem>
          <Button btn type="primary" size="large" @click="signIn">登录</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import API from "@/API";
export default {
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      rules: {
        username: [{ required: true, message: "账号必填", trigger: "blur" }],
        password: [{ required: true, message: "密码必填", trigger: "blur" }]
      }
    };
  },
  methods: {
    signIn() {
      this._validateForm("form", () => {
        API.admin.signIn(this.form).then(({ code, data }) => {
          console.log('code :>> ', code);
          console.log('data :>> ', data);
          if (code === 0) {
            this.$store.commit("setAdmin", data);
            this._jumpTo("Main");
          }else{
              this.$Notice.warning({
                  title:data
              })
          }
        });
      });
    }
  }
};
</script>

<style lang='less'>
@import "../../custom.less";
.sign-in {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  div[wrapper] {
    width: 400px;
    padding: 30px 30px 15px;
    background-color: RGBA(255, 255, 255, 0.9);
    border-radius: 4px;
    box-shadow: 0 0 16px 2px RGBA(164, 163, 165, 1);
    position: relative;
    div[title] {
      font-size: 30px;
      font-weight: bold;
      color: @primary-color;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      img {
        height: 30px;
      }
    }
    .ivu-form {
      button[btn] {
        float: right;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/signin/index.vue